import watchUtils = require("esri/core/watchUtils");
import GroupLayer = require("esri/layers/GroupLayer");
import MapImageLayer = require("esri/layers/MapImageLayer");
import FeatureLayer = require("esri/layers/FeatureLayer");
import * as layerSource from "./layerSource";
import BuildPopups from "./buildPopups";

// MYP

export const mypStructuresLayerCurYear = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPStructuresLayerCurYear
    }
  ]
});

export const mypStructuresLayerFutureYears = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPStructuresLayerFutureYears
    }
  ]
});

export const mypRoadwayLayerCurYear = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPRoadwayLayerCurYear
    }
  ]
});

export const mypRoadwayLayerFutureYears = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPRoadwayLayerFutureYears
    }
  ]
});

export const mypSpotLayerCurYear = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPSpotLayerCurYear
    }
  ]
});

export const mypSpotLayerFutureYears = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.MYPSpotLayerFutureYears
    }
  ]
});

// Annual

export const annualBridgeImprovementLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.AnnualBridgeImprovement
    }
  ]
});

export const annualConstructionLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.AnnualConstructionLayer
    }
  ]
});

export const annualEngineeringLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.AnnualEngineeringLayer
    }
  ]
});

export const annualLandAcqLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.AnnualLandAcqLayer
    }
  ]
});

// For The Record 

export const ftrStructuresLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.FTRStructuresLayer
    }
  ]
});
export const ftrEngineeringLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.FTREngineeringLayer
    }
  ]
});
export const ftrLandAcqLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.FTRLandAcqLayer
    }
  ]
});
export const ftrConstructionLayer = new MapImageLayer({
  url: layerSource.serverUrl,
  listMode: "hide-children",
  visible: false,
  minScale: 750000,
  sublayers: [
    {
      id: layerSource.FTRConstructionLayer
    }
  ]
});

export const programmingGroupLayer = new GroupLayer({
  title: "Programming Data",
  id: "07 - MYP",
  visible: true,
  visibilityMode: "independent",
  layers: [
    ftrLandAcqLayer, 
    ftrConstructionLayer, 
    ftrEngineeringLayer, 
    ftrStructuresLayer, 

    annualLandAcqLayer, 
    annualConstructionLayer, 
    annualEngineeringLayer,
    annualBridgeImprovementLayer, 

    mypRoadwayLayerFutureYears, 
    mypRoadwayLayerCurYear, 
    mypSpotLayerFutureYears, 
    mypStructuresLayerFutureYears, 
    mypSpotLayerCurYear, 
    mypStructuresLayerCurYear, 
  ]
});

export const programmingFeatureLayers = new Map();

programmingGroupLayer.layers.forEach(layer => {
  watchUtils.whenTrueOnce(layer, "loaded", () => {
    // console.log("loaded  ", layer.title);
    if (layer instanceof MapImageLayer ) {
      layer.loadAll().then(() => {
        // console.log("loadAll complete ", layer.title);
        BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
        // console.log("createFeatureLayer  ", layer.title);
        layer.sublayers.getItemAt(0).createFeatureLayer().then(featureLayer => {
          // console.log("loaded featureLayer  ", layer.title);
          featureLayer.listMode = "hide";
          featureLayer.visible = false;
          featureLayer.opacity = 0;
          featureLayer.outFields = ["*"];
          featureLayer.load().then(() => {
            // console.log("loaded - featureLayer.sourceJSON.name ", featureLayer.sourceJSON.name);
            layer.title = featureLayer.sourceJSON.name;
            layer.sublayers.getItemAt(0).title = featureLayer.sourceJSON.name;
            programmingFeatureLayers.set(layer.title, featureLayer);
            programmingGroupLayer.add(programmingFeatureLayers.get(layer.title) as FeatureLayer);
          })
        });
      });
    }
  });
});
